import { gql } from "@apollo/client";

export const GET_ALL_CANAL = gql`
query GetCanal
{
    canal
    {
        success
        error
        valorEsperado {
            idCanal
            descripcion
        }
    }
}
`;

export const adaptCanal = (canal) => {
  return {
    id: canal.idCanal,
    displayName: canal.descripcion,
    detalle: canal?.detalle ?? ''
  };
};

export const adaptCanalArray = (
allCanal) =>
{
  return structuredClone(allCanal)?.
  map((canal) => adaptCanal(canal));
};